import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk /**the middleware */ from 'redux-thunk'; //for async
import {rootReducer} /**the reducer that combine all the reducer */ from './reducers';
import {ILoadingComponents} from "../interfaces/datesGlobalState.interface";
import {ActionsTypes} from "./consts/actionsTypes";

const middleware = [thunk];

// Creates store that contain many sub-states.
export const store = createStore(
    rootReducer,
    {},
    composeWithDevTools(applyMiddleware(...middleware)),
);

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch


export const setIsLoading= (isLoading: Partial<ILoadingComponents>) => (dispatch: AppDispatch) => {
    dispatch({type: ActionsTypes.SET_IS_LOADING, payload: {isLoading}})
}